import {messagesService} from "@dv5/api"

class CanvasLayersService {
    updateSelectedLayers(canvasId: string, layerIds: string[]) {
        messagesService.send('canvas.update-selected-layers', {
            canvasId,
            layerIds,
        })
    }

    cloneLayer(canvasId: string, layerId: string) {
        messagesService.send('canvas.clone-layer', {
            canvasId,
            layerId,
        })
    }
}

export const canvasLayersService = new CanvasLayersService()
